<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    user() {
      return JSON.parse(localStorage.getItem('user'));
    },
    isAuthenticated() {
      return this.user !== null;
    },
    isAuthPage() {
      const path = (this.$route?.path || '').toLowerCase();
      return ['/signin', '/signup', '/forgot-password'].includes(path);
    },
    isHomePage() {
      const path = (this.$route?.path || '').toLowerCase();
      return path === '/';
    },
    isThemedPage() {
      const path = (this.$route?.path || '').toLowerCase();
      return !['/', '/signin', '/signup', '/forgot-password'].includes(path);
    }
  },
  watch: {
    '$route.path'() {
      this.applyGlobalTheme();
    }
  },
  methods: {
    applyGlobalTheme() {
      if (typeof document === 'undefined') return;
      const body = document.body;
      body.classList.remove('theme-light', 'theme-dark');

      if (!this.isThemedPage) return;

      const theme = localStorage.getItem('appTheme') === 'dark' ? 'dark' : 'light';
      body.classList.add(theme === 'light' ? 'theme-light' : 'theme-dark');
    },
    handleThemeChange() {
      this.applyGlobalTheme();
    },
    logout() {
      localStorage.removeItem('user');
      this.$router.push({ name: 'SignIn' });
    }
  },
  mounted() {
    this.applyGlobalTheme();
    window.addEventListener('app-theme-change', this.handleThemeChange);
  },
  beforeUnmount() {
    window.removeEventListener('app-theme-change', this.handleThemeChange);
  }
}
</script>
